module.exports = __webpack_public_path__ + "static/media/ws.de84cb04.svg";